import Dexie from 'dexie';

export const db = new Dexie('HardwareShopDB');

db.version(1).stores({
  settings: 'id',
  categories: '++id, name',
  units: '++id, name',
  products: '++id, name, sku, category, brand, active',
  variants: '++id, productId, sku',
  customers: '++id, name, phone',
  suppliers: '++id, name, phone',
  invoices: '++id, number, date, customerId, status, paymentStatus',
  invoiceItems: '++id, invoiceId, productId',
  payments: '++id, invoiceId, customerId, date',
  stockTransactions: '++id, productId, date, type, invoiceId',
  meta: 'key'
});

db.version(2).stores({
  products: '++id, name, sku, category, brand, active, parentId',
  invoiceItems: '++id, invoiceId, productId',
});

export const DEFAULT_SETTINGS = {
  id: 'main',
  businessName: 'My Hardware Shop',
  ownerName: '',
  logoDataUrl: '',
  address: '',
  phone: '',
  email: '',
  gstin: '',
  state: 'Uttar Pradesh',
  invoicePrefix: `INV-${new Date().getFullYear()}-`,
  invoiceCounter: 0,
  gstEnabled: true,
  defaultGstRate: 18,
  currency: '₹',
  defaultPaymentMethod: 'Cash',
  allowNegativeStock: false,
  printFormat: 'A4',
  invoiceFooter: 'Thank you for your business',
  language: 'en',
  demoDataLoaded: false,
};

export async function getSettings() {
  let s = await db.settings.get('main');
  if (!s) {
    await db.settings.put(DEFAULT_SETTINGS);
    s = DEFAULT_SETTINGS;
  }
  return { ...DEFAULT_SETTINGS, ...s };
}

export async function updateSettings(patch) {
  return db.transaction('rw', db.settings, async () => {
    const s = await getSettings();
    const merged = { ...s, ...patch, id: 'main' };
    await db.settings.put(merged);
    return merged;
  });
}
